import React from 'react';

import {
	FileInput,
	styled
} from 'ps-gui';
import { getPhrase } from '../data/phrases';

const Wrapper = styled.div`
	position: relative;
	padding: 40px;
	border: 1px dashed #C6DAE7;
	border-radius: 15px;
	text-align: center;
	margin-bottom: ${props => props.marginBottom};
	&.hover {
		background: #fff;
		> * {
			opacity: 0.2;
		}
	}
`;

const Or = styled.div`
	font-size: 14px;
	color: #575757;
	line-height: 32px;
	font-weight: 400;
`;

const DragText = styled.div`
	color: #306DA0;
	font-size: 16px;
	line-height: 32px;
	font-weight: 400;
`;

export default class UploadPane extends React.PureComponent {
	constructor() {
		super();
		this.onFileUploadRequested = this.onFileUploadRequested.bind(this);
		this.onDrop = this.onDrop.bind(this);
		this.onDragOver = this.onDragOver.bind(this);
		this.onDragEnter = this.onDragEnter.bind(this);
		this.onDragLeave = this.onDragLeave.bind(this);
		this.enterCounter = 0;
	}

	onFileUploadRequested(files) {
		if (this.props.onFileUploadRequested) {
			this.props.onFileUploadRequested(files);
		}
	}

	addHoverClass(target) {
		if (this.enterCounter++ > 0) {
			return;
		}
		const up = target.closest('.uploadPane');
		up.classList.add('hover');
	}

	removeHoverClass(target) {
		if (--this.enterCounter > 0) {
			return;
		}
		const up = target.closest('.uploadPane');
		up.classList.remove('hover');
	}

	onDragEnter(e) {
		e.preventDefault();
		this.addHoverClass(e.target);
	}

	onDragLeave(e) {
		e.preventDefault();
		this.removeHoverClass(e.target);
	}

	onDragOver(e) {
		e.preventDefault();
	}

	onDrop(e) {
		e.preventDefault();
		this.removeHoverClass(e.target);
		this.enterCounter = 0;
		this.onFileUploadRequested(e.dataTransfer.files);
	}

	render() {
		return (
			<Wrapper
				className="uploadPane"
				marginBottom={this.props.marginBottom}
				onDrop={this.onDrop}
				onDragEnter={this.onDragEnter}
				onDragOver={this.onDragOver}
				onDragLeave={this.onDragLeave}
			>
				<DragText>{this.props.dragText}</DragText>
				<Or>{getPhrase('or')}</Or>
				<FileInput
					type="medium"
					text={this.props.buttonText}
					onChange={this.onFileUploadRequested}
				/>
			</Wrapper>
		);
	}
}
